import { Component, OnInit, Renderer2, Output, EventEmitter } from '@angular/core';
import templateString from './candidateTypeForm.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../data.service';
import { CandidateType } from '../../../models/candidateType.model';
import { EnvironmentService } from '../../../environment.service';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString
})
export class CandidateTypeFormComponent implements OnInit {
    @Output() action = new EventEmitter();
	
	public candidateTypeId: any;
	public schedulePeriodId: any;

	public candidateType: any;
	public submitted: boolean;	
	public actionTitle: string;
	public colors: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2,
		private toastr: ToastrService,
		private dataService: DataService,
		private environmentService: EnvironmentService
	) {
		this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
	}

  	ok(isValid) {
		this.submitted = true;
		
		if (isValid && this.candidateType.color_id != null) {
			if (this.candidateTypeId === null) {
				this.http.post("candidate_types", this.candidateType).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			} else {
				this.http.put("candidate_types/" + this.candidateType.id, this.candidateType).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			}
		}
  	}

  	cancel() {
		this.bsModalRef.hide();
  	}

    ngOnInit() {
		this.colors = this.dataService.colors;

		if (this.candidateTypeId === null) {
			this.actionTitle = "toevoegen";
			this.candidateType = new CandidateType();
		} else {
			this.actionTitle = "wijzigen";
			this.http.get("candidate_types/" + this.candidateTypeId).subscribe(x => {
				this.candidateType = x;
			})
		}
    }
}
